module.exports = __webpack_public_path__ + "img/game_on.736aa917.png";